<template>
  <div>
    <v-card>
      <v-toolbar color="white" class="elevation-1">
        <v-toolbar-title class="black--text font-weight-light">Nova Cidade</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-switch class="pt-switch" pt-2 v-if="city && city.active != undefined || null"
            @click.prevent="city.active  == true ? desactivationDialog = true : activateCity()"
            :label='city.active ? "Ativa" : "Inativa"' v-model="city.active"></v-switch>
          <v-btn title="Cancelar" @click="cancel" color="error" icon round flat>
            <v-icon large>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container fluid grid-list-xl>
        <v-card-text>
          <v-layout wrap row>
            <v-flex xs12>
              <v-select box prepend-icon="business" :items="states" item-text="name" item-value="uf" v-model="city.uf"
                label="Estado" required @change="filterCities"></v-select>
            </v-flex>
            <v-flex xs12>
              <v-select box prepend-icon="label" :items="citiesOffState" v-model="city.name" label="Cidade" required
                :disabled="city.uf == undefined"></v-select>
            </v-flex>
            <v-flex xs12>
              <v-text-field box prepend-icon="attach_money" v-model="city.busPassValue"
                label="Valor do passe de ônibus (R$)" type="number" min="0"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" round block @click.stop.prevent="save();">Salvar</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </div>
</template>

<script>

  // SERVICES //
  import CityService from "../../service/CityService";
  import States from '@/utils/StatesAndCitiesBR'

  export default {
    data: () => ({
      city: {},
      citiesOffState: [],
      states: States,
    }), //data()

    methods: {
      async save() {
        try {
          this.city = await CityService.save(this.city);
          await this.$eventHub.$emit("savedNewCity");
          this.$emit('savedCity')
        } catch (error) {
          this.$eventHub.$emit("newCityNotSaved");
        }
      }, //save()

      cancel() {
        this.city={};
        this.$eventHub.$emit("cancelDialogAddNewCity");
        this.$emit('cancelNewCity')
      }, //cancel()
      filterCities() {
        this.states.forEach(state => {
          if (state.uf == this.city.uf) {
            this.citiesOffState = state.cities
            this.city.state = state.name
          }
        });
      }, //
    }, //methods
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/budget/FormCity.vue